import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { BaseType } from "../../types/formRVEO";
import { MODALITIES } from "../../Utils/constants";

/**
 * Hook para manejar la gestión de modalidades
 */
export const useModalities = (
  modData: any[],
  deferredYearsData: BaseType<number>[],
  prestacionWatch?: string
) => {
  const [modalities, setModalities] = useState<any>([]);
  const [selectedModalitie, setSelectedModalitie] = useState<any>();
  const [showModalMod, setShowModalMod] = useState<boolean>(false);
  const [modalitiesOptions, setModalitiesOptions] = useState<any>([]);
  const [deferredYears, setDeferredYears] = useState<BaseType<number>[]>([]);

  useEffect(() => {
    if (modData.length > 0) {
      setModalitiesOptions(modData);
    }
  }, [modData]);

  useEffect(() => {
    if (deferredYearsData.length > 0) {
      setDeferredYears(deferredYearsData);
    }
  }, [deferredYearsData]);

  const methodsModalities = useForm({
    mode: "onChange",
  });

  const {
    handleSubmit: handleSubmitModalitie,
    register: registerModalitie,
    errors: errorsModalitie,
    reset: resetModalities,
    watch: watchModalitie,
    setValue: setValueModalitie,
  } = methodsModalities;

  const modalitiesSelect = watchModalitie("modalities");
  const currencyMod = watchModalitie("currencyMod");
  const defYearsMod = watchModalitie("defYearsMod");
  const tempYearsMod = watchModalitie("tempYearsMod");
  const guarYearsMod = watchModalitie("guarYearsMod");

  const deleteModalitie = (modalitieP: any) => {
    const indexModalitie = modalities.findIndex(
      (parient: any) => modalitieP.id === parient.id
    );
    const newModalities = [
      ...modalities.slice(0, indexModalitie),
      ...modalities.slice(indexModalitie + 1),
    ];
    setModalities(newModalities);
  };

  const handleOpenModalAddModalities = () => {
    setSelectedModalitie(null);
    setShowModalMod(true);
  };

  const handleCloseModalModalities = () => {
    setShowModalMod(false);
    setSelectedModalitie(null);
    resetModalities();
  };

  const handleOpenModalEditModalitie = (modalitie: any) => {
    setShowModalMod(true);
    setSelectedModalitie(modalitie);
  };

  const handleAddModalitie = (modalitie: any) => {
    if (selectedModalitie) {
      const newTest = modalities.map((item: any) => {
        return item.id === selectedModalitie.id
          ? { id: selectedModalitie.id, ...modalitie }
          : { ...item };
      });
      setModalities(newTest);
    } else {
      setModalities([
        ...modalities,
        {
          id: modalities.length + 1,
          ...modalitie,
        },
      ]);
    }
    resetModalities();
    setSelectedModalitie(null);
    setShowModalMod(false);
  };

  // useEffect para filtrar años diferidos según modalidad
  useEffect(() => {
    if (modalitiesSelect === MODALITIES.RENTA_VITALICIA_ESCALONADA) {
      const deferredYearsSelect = deferredYearsData.filter((defYear: any) => {
        return defYear.value === 5 || defYear.value === 10;
      });
      setDeferredYears(deferredYearsSelect);
    } else if (modalitiesSelect === MODALITIES.RENTA_TEMPORAL_VITALICIA_DIFERIDA) {
      setDeferredYears(deferredYearsData);
    } else {
      setDeferredYears(deferredYearsData);
    }
  }, [modalitiesSelect, deferredYearsData]);

  // useEffect para resetear campos de modalidad
  useEffect(() => {
    setValueModalitie("currencyMod", "");
    setValueModalitie("defYearsMod", "");
    setValueModalitie("tempYearsMod", "");
    setValueModalitie("guarYearsMod", "");
  }, [modalitiesSelect]);

  // useEffect para filtrar modalidades según prestación
  useEffect(() => {
    if (prestacionWatch) {
      const modFilter = modData.filter((mod: any) => {
        return (
          ((prestacionWatch === "IP" ||
            prestacionWatch === "IT" ||
            prestacionWatch === "S") &&
            (mod.value === MODALITIES.RENTA_VITALICIA || mod.value === MODALITIES.RENTA_TEMPORAL_VITALICIA_DIFERIDA)) ||
          prestacionWatch === "J"
        );
      });
      setModalitiesOptions(modFilter);
    }
  }, [prestacionWatch, modData]);

  return {
    modalities,
    setModalities,
    selectedModalitie,
    showModalMod,
    setShowModalMod,
    modalitiesOptions,
    setModalitiesOptions,
    deferredYears,
    setDeferredYears,
    deleteModalitie,
    handleOpenModalAddModalities,
    handleCloseModalModalities,
    handleOpenModalEditModalitie,
    handleAddModalitie,
    handleSubmitModalitie,
    registerModalitie,
    errorsModalitie,
    resetModalities,
    modalitiesSelect,
    currencyMod,
    defYearsMod,
    tempYearsMod,
    guarYearsMod,
    setValueModalitie,
  };
};
